import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const WaterproofGrippedPants = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.pants.WaterproofGrippedPants.itemName}
      name={AW23.pants.WaterproofGrippedPants.itemName}
      price={AW23.pants.WaterproofGrippedPants.itemPrice}
      fabric={AW23.pants.WaterproofGrippedPants.itemFabric}
      src={AW23.pants.WaterproofGrippedPants.sizeChart}
      divId={AW23.pants.WaterproofGrippedPants.shopifyDivId}
      mainId={AW23.pants.WaterproofGrippedPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.pants.WaterproofGrippedPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.pants.WaterproofGrippedPants.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default WaterproofGrippedPants;
